export default ($node: HTMLElement) => {
	const inBackend = $node.getAttribute("data-backend");

	const accordionOpenBtn = $node.querySelector("[data-select=accordionOpen]");
	const accordionContent = $node.querySelector("[data-select=accordionContent]");
	const closeClassName = $node.querySelector(" [data-contentClose]")?.getAttribute("data-contentClose");
	const accordionIcon = $node.querySelector("[data-accordionIcon]");

	if (accordionOpenBtn && accordionContent && closeClassName && accordionIcon) {
		if (inBackend !== "true") {
			accordionOpenBtn.addEventListener("click", function() {
				accordionContent.classList.toggle(closeClassName);
				accordionIcon.classList.toggle(accordionIcon?.getAttribute("data-accordionIcon") ?? "")
			});
		}
	}
}
